import { Box } from 'src/components';
import Flag from "react-world-flags";

export default function UserFlag({ countryCode, size = 16, sx }) {

    return (
        <Box
            sx={{
                width: size,
                height: size,
                borderRadius: '50%',
                overflow: 'hidden',
                boxShadow: 1,
                ...sx
            }}>
            <Flag
                code={countryCode}
                style={{ width: '100%', height: '105%', objectFit: 'cover' }}
            />
        </Box>
    );
}
